import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

// UI
import { Box } from '@chakra-ui/react'
import ALDetailModal from '../components/ALDetailModal'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'

import ALListHeader from '../components/ALListHeader'
import getALTableColumns from '../constants/alTableColumns'
import useAL from '../useAL'
import { LoadingSection } from '@/components/Elements'

const ALListPage = () => {
  const title = 'AL'

  // Modal State
  const [modalDetail, setModalDetail] = useState({
    show: false,
    isCreate: true,
  })

  //Table State
  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:al`, {})
  const query = convertTableStateToQuery(storedTableState)

  // Hooks
  const dispatch = useDispatch()
  const { useFetchAllALs, useRemoveAL, useUpdateAL } = useAL()
  const { data: alResponse, isLoading } = useFetchAllALs(query)

  const removeAL = useRemoveAL()
  const updateAL = useUpdateAL()

  // Handler
  const handleAdd = () => {
    setModalDetail({
      show: true,
      isCreate: true,
      detail: {},
    })
  }

  const handleOnRowClick = (row) => {
    setModalDetail({
      show: true,
      isCreate: false,
      detail: row?.original,
    })
  }

  const handleDelete = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await removeAL.mutateAsync(id)
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, removeAL]
  )

  const handleActivate = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await updateAL.mutateAsync({ id, data: { isDeleted: false } })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, updateAL]
  )

  const defaultColumns = getALTableColumns({
    handleActivate,
    handleDelete,
  })

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <ALDetailModal modalDetail={modalDetail} setModalDetail={setModalDetail} />
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <ALListHeader title={title} handleAdd={handleAdd} query={query} />
        <Box p={5} overflow="scroll">
          <FullTable
            data={alResponse?.data ? alResponse.data : []}
            rowCount={alResponse?.count}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
          />
        </Box>
      </Box>
    </>
  )
}

export default ALListPage
